/**
 * Simple HTTPGet client wrapped around window.fetch
 * @export
 * @class HTTPGetClient
 */
export default class HTTPGetClient {
    config: RequestInit = {
        method: 'GET',
				credentials: 'include'
    };

    baseUrl = '/';

    constructor({ baseUrl }: { baseUrl: string }) {
        this.baseUrl = baseUrl;
    }

    get<R = any>(endpoint: string, config: RequestInit = {}) {
        return this.request<R>(endpoint, { ...this.config, ...config });
    }

    post<R = any, D = any>(endpoint: string, data: D) {
        const defaultConfig = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        };
        return this.request<R>(endpoint, defaultConfig);
    }

    private request<T = any>(endpoint: string, config: RequestInit) {
        return fetch(`${this.baseUrl}/${endpoint}`, config).then(async (response) => {
            const data = await response.json();
            if (response.ok) {
                return data as T;
            } else {
                return Promise.reject(data);
            }
        });
    }
}
